import { useEffect, useRef, useState } from "react";
import { Button } from './Button';
import restart_icon from 'url:../assets/restart.svg'
import play_icon from 'url:../assets/play.svg';
import pause_icon from 'url:../assets/pause.svg';
import '../styles/music-player.css';

export function MusicPlayer(props: {audio: string, loop ?: boolean, autoplay ?: boolean}) {
    const [audioSrc, setAudioSrc] = useState(props.audio);
    const audioRef = useRef(new Audio(audioSrc));
    audioRef.current.volume = 0.15;
    const [audioTime, setAudioTime] = useState(0);
    const [audioDuration, setAudioDuration] = useState(audioRef.current.duration);
    const [audioFill, setAudioFill] = useState(0);
    const loop = props.loop === undefined ? true : props.loop;
    const autoplay = props.autoplay === undefined ? false : props.autoplay;
    const [paused, setPaused] = useState(!autoplay);

    const restartAudio = () => {
        audioRef.current.currentTime = 0;
        if (!paused)
            audioRef.current.play();
    };

    const updateAudioTime = () => {
        setAudioTime(audioRef.current.currentTime);
        setAudioDuration(audioRef.current.duration);
    };

    const endAudio = () => {
        if (loop)
            restartAudio();
    };

    const handlePlayPause = () => {
        if (paused)
            setPaused(false);
        else
            setPaused(true);
    };

    useEffect(() => {
        audioRef.current.src = audioSrc;
        restartAudio();
    }, [audioSrc]);

    useEffect(() => {
        setAudioFill(Math.round(audioTime / audioDuration * 100));
    }, [audioTime, audioDuration]);

    useEffect(() => {
        if (paused)
            audioRef.current.pause();
        else
            audioRef.current.play();
    }, [paused]);

    return (
        <div className='music-player'>
            <audio 
                ref={audioRef} 
                src={audioSrc} 
                autoPlay={autoplay} 
                onTimeUpdate={updateAudioTime} 
                onLoadedMetadata={updateAudioTime} 
                onEnded={endAudio}
            />
            <Button img={paused ? play_icon : pause_icon} onClick={handlePlayPause} />
            <div className='music-player-bar'> 
                <div className="music-player-bar-fill" style={{width: audioFill+"%", height: "100%"}} />
            </div>
            <Button img={restart_icon} onClick={restartAudio} />
        </ div>
    );
}